import React from 'react';

const dropdownNavigationHOC = (Component) => {
  class HOC extends React.Component {
    constructor (props) {
      super(props);
      this.onKeyDownList = this.onKeyDownList.bind(this);
    }

    onKeyDownList (event) {
      if (!event) return;
      event.stopPropagation();
      const target = event.target;
      const previousSibling = target.previousElementSibling;
      const nextSibling = target.nextElementSibling;
      if (13 === event.keyCode && -1 !== target.tabIndex) {
        // If the user hits enter we trigger the onclic event handler of the selected list element
        target.click();
      }
      if (40 === event.keyCode && nextSibling && -1 !== nextSibling.tabIndex) {
        // If the user presses the down arrow we move to the next item on the list in the dropdown.
        event.preventDefault();
        nextSibling.focus();
        if (target.classList.contains('gray-light-bg')) {
          // If the item in the dropdown is hightlighted with a gray background,
          // remove the background when the user cycles to the next list
          target.classList.remove('gray-light-bg');
        }
      }
      if (38 === event.keyCode && previousSibling && -1 !== previousSibling.tabIndex) {
        // If the user presses the up button go the previous item on the list
        event.preventDefault();
        previousSibling.focus();
      }
    }

    render () {
      return (
        <Component
          {...this.props}
          onKeyDownList={this.onKeyDownList}
        />
      );
    }
  }
  return HOC;
};

export default dropdownNavigationHOC;
